import bugsnag from '@bugsnag/js';
import bugsnagVue from '@bugsnag/plugin-vue';
import Vue from 'vue';

const bugsnagClient = bugsnag({
  apiKey: '7585a84359b9d52d04eb78724584bd0d',
  releaseStage: process.env.NODE_ENV,
});
bugsnagClient.use(bugsnagVue, Vue);

export default bugsnagClient;
